import request from '../utils/Request';
import { Methods } from '../config';

const baseURL = 'resourceOneGroup';

const resourceOneGroupService = {
  getItems: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/data`,
      data,
    });
  },

  updateItem: (data) => {
    return request({
      method: Methods.PUT,
      resource: `${baseURL}`,
      data,
    });
  },

  createItem: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}`,
      data,
    });
  },

  deleteItem: (id) => {
    return request({
      method: Methods.DELETE,
      resource: `${baseURL}/${encodeURIComponent(id)}`,
    });
  },

  orderItem: (id, data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/orderData/${encodeURIComponent(id)}`,
      data,
    });
  },
};
export default resourceOneGroupService;
